import GlobalNavLink from '../parts/navlinks/GlobalNavLink'
import house from '../../assets/images/svg/house'
import christmasGift from '../../assets/images/christmasGift.jpg'

const LandingPageDisconnectedElement = ({ cssGlobal = "",
  cssFirstDiv = "", cssFirstDivSpan = ["", ""], firstDivSpanTxt = ["Un premier texte...", "Un autre premier texte !"], firstDivSpanNavlink = {
    to: "home",
    txt: "Accueil",
    css: "",
    img: null,
    alt: "Un cadeau"
  },
  cssSecondDiv = "", imgSecondDiv = ["w-24 h-24 rounded-full", null, "un cadeau de Noël"], cssSecondDivSpan = "", secondDivSpanTxt = "", secondDivChild = null,
  cssThirdDiv = "", cssThirdDivSpan = "", thirdDivSpanTxt = ["Un premier texte...", "... et un second texte"] }) => {

  const sectionCss = `w-full global-px bg-ivory flexJustifyItemsCenter flex-col gap-6 font-semibold ${cssGlobal}`
  const divWidth = 'w-full md:w-9/12'
  const firstDivCss = `${divWidth} gap-6 flexJustifyItemsCenter ${cssFirstDiv}`
  const firstDivFirstSpanCss = `text-2xl text-darkOrange ${cssFirstDivSpan[0]} md:text-3xl`
  const firstDivSecondSpanCss = `${firstDivFirstSpanCss} ${cssFirstDivSpan[1]}`
  const firstDivNavLinkCss = `text-darkRed ${firstDivSpanNavlink.css}`
  const firstDivNavLinkImg = firstDivSpanNavlink.img ? firstDivSpanNavlink.img : house
  const secondDivCss = `${divWidth} gap-6 flexJustifyItemsCenter ${cssSecondDiv}`
  const secondDivImg = imgSecondDiv[1] ? imgSecondDiv[1] : christmasGift
  const secondDivSpanCss = `text-xl text-right text-darkRed ${cssSecondDivSpan} md:text-2xl`
  const thirdDivCss = `${divWidth} font-semibold text-darkRed flex flex-col gap-2 ${cssThirdDiv}`
  const thirdDivSpanCss = `text-lg border-darkRed ${cssThirdDivSpan} md:text-xl`

  return (
    <section className={sectionCss}>
      <div className={firstDivCss}>
        <div>
          <span className={firstDivFirstSpanCss}>{firstDivSpanTxt[0]}</span>
          <span className={firstDivSecondSpanCss}>{firstDivSpanTxt[1]}</span>
        </div>
        <GlobalNavLink to={firstDivSpanNavlink.to} txt={firstDivSpanNavlink.txt} css={firstDivNavLinkCss} img={firstDivNavLinkImg} alt={firstDivSpanNavlink.alt} />
      </div>
      <div className={secondDivCss}>
        {
          secondDivChild ? secondDivChild : <>
            <img className={imgSecondDiv[0]} src={secondDivImg} alt={imgSecondDiv[2]} />
            <span className={secondDivSpanCss}>{secondDivSpanTxt}</span>
          </>
        }
      </div>
      <div className={thirdDivCss}>
        <span className={thirdDivSpanCss}>
          {thirdDivSpanTxt[0]}
        </span>
        <span className={thirdDivSpanCss}>
          {thirdDivSpanTxt[1]}
        </span>
      </div>
    </section>
  )
}

export default LandingPageDisconnectedElement